// React components
import { useState } from "react";

// @mui material components
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import breakpoints from "assets/theme-dark/base/breakpoints";

// Material Dashboard 2 PRO React TS components
import Sideform from "examples/Sideform";

// Country form components
import PrevProjForm from "./components/PrevProjForm";
import ExportPrevProjForm from "./components/ExportPrevProjForm";
import MainContent from "./components/MainContent";

// Contexts
import FormPrevProjContextProvider, { useFormPrevProjContext } from "contexts/contextFormPrevProj";
import { useUserContext } from "contexts/contextUser";

function PrevProj(): JSX.Element {
  return (
    <FormPrevProjContextProvider>
      <MainContent />
      <PrevProjSideform />
    </FormPrevProjContextProvider>
  );
}

function PrevProjSideform(): JSX.Element {
  const { isAuthenticated } = useUserContext();
  const { isLoading, isError } = useFormPrevProjContext();

  const [tabValue, setTabValue] = useState<number>(0);
  const handleSetTabValue = (event: any, newValue: number) => setTabValue(newValue);
  const isViewTab = tabValue === 0;
  const isExportTab = tabValue === 1;
  const showAppBar = isAuthenticated && !isLoading && !isError;

  return (
    <Sideform title="Data Selection" color="info">
      {showAppBar && (
        <AppBar position="relative" sx={{ marginBottom: 2 }}>
          <Tabs
            orientation={window.innerWidth < breakpoints.values.md ? "vertical" : "horizontal"}
            value={tabValue}
            onChange={handleSetTabValue}
          >
            <Tab label="View" />
            <Tab label="Export" />
          </Tabs>
        </AppBar>
      )}

      {isViewTab && <PrevProjForm />}
      {isExportTab && isAuthenticated && <ExportPrevProjForm />}
    </Sideform>
  );
}

export default PrevProj;
